// extracted by mini-css-extract-plugin
module.exports =  {"container":"sbJdK1XW6IgI_t4ePz3k","growthCreditsCell":"nJimFYagrxsOaTxxEf7K","content":"f2F3SIi2s0wfKIGqWfOW","name":"f33JBi97JjXzTZ9UVgH0"};